import * as Types from '../../../../generated/graphql';
import { gql } from '@apollo/client';
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

export type GetCommunityUserEmailQueryVariables = Types.Exact<{
  id: Types.Scalars['Int'];
}>;

export type GetCommunityUserEmailQuery = {
  __typename?: 'Query';
  findUserById?: {
    __typename?: 'User';
    id: number;
    email?: string | null;
    verifiedEmail?: string | null;
    allowEmails?: boolean | null;
  } | null;
};

export const GetCommunityUserEmailDocument = gql`
  query GetCommunityUserEmail($id: Int!) {
    findUserById(id: $id) {
      id
      email
      verifiedEmail
      allowEmails
    }
  }
` as unknown as DocumentNode<
  GetCommunityUserEmailQuery,
  GetCommunityUserEmailQueryVariables
>;
